import { Box, Heading, Input, Button, Text, useToast } from "@chakra-ui/react";
import { useState } from "react";
const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const submit = async () => {
    setLoading(true);
    try {
      await fetch(`${API_BASE}/auth/request-password-reset`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ email }),
      });
      toast({ title: "Check your email for a reset link.", status: "success" });
    } catch {
      toast({ title: "Something went wrong.", status: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt={16} p={6} borderWidth="1px" borderRadius="lg">
      <Heading size="md" mb={4}>Forgot your password?</Heading>
      <Input placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} mb={3}/>
      <Button colorScheme="green" onClick={submit} isLoading={loading} isDisabled={!email}>Send reset link</Button>
      <Text fontSize="sm" color="gray.600" mt={3}>We’ll email you a link to reset it.</Text>
    </Box>
  );
}
